import { mapActions } from 'vuex';
import moment from 'moment';
import constants from '@/constants';
import { isDebugOn } from '@/logger';

const dashboardNotificationMixin = {
  props: {
    autoClose: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: constants.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
    },
    data: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    theme: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      timeout: null,
      interacted: false,
    };
  },
  methods: {
    ...mapActions('notifications', ['remove']),
    onClose() {
      this.remove(this.index);
    },
    onInteract() {
      this.interacted = true;
    },
  },
  mounted() {
    this.$el.addEventListener('click', () => this.onInteract());
    if (this.autoClose && !isDebugOn()) {
      this.timeout = setTimeout(() => {
        if (!this.interacted) this.onClose();
      }, this.closeTimeout);
    }
  },
  computed: {
    timeElapsed() {
      const elapsed = moment.utc(this.data.dateCreated).fromNow(true);
      return `${elapsed} ago`;
    },
  },
  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },
};


export default dashboardNotificationMixin;



// WEBPACK FOOTER //
// ./src/mixins/dashboardNotification.js